import React, { useState, useMemo } from "react";
import { useLocation } from "react-router-dom";
import _ from "lodash";
import { Typography, TextField, Box } from "@mui/material";
import ResponsiveDrawer from "views/components/ResponsiveDrawer";
import { Autocomplete } from "@mui/material";
import { MaterialReactTable } from "material-react-table";
import AllKampoData from "data/all-kampo.json";
import OTCKampoData from "data/otc-kampo.json";
import { matchesKanaSearch } from "utils/kanaUtils";

function ReleventSearch() {
  const params = new URLSearchParams(useLocation().search);
  const kampo = params.get("q");
  const [selectedKampo, setSelectedKampo] = useState();
  const [releventOTCKampo, setReleventOTCKampo] = useState();
  const [searched, setSearched] = useState();
  const resetStates = () => {
    setSelectedKampo();
    setReleventOTCKampo();
  };
  const handleChange = (_, data) => {
    const selectedKampoName = data?.name;
    if (selectedKampoName) {
      window.location.href = `/relevent-search?q=${selectedKampoName}`;
    } else {
      resetStates();
    }
  };
  const search = (selectedKampoName) => {
    const selectedKampoData = AllKampoData.find(
      (item) => item.name === selectedKampoName
    );
    if (!selectedKampoData) return;
    setSelectedKampo(selectedKampoData);
    let matchedKampo = [].concat(_.cloneDeep(OTCKampoData)).map((item) => {
      item.count = 0;
      return item;
    });
    selectedKampoData.set.split(",").forEach((a) => {
      matchedKampo.forEach((b, i) => {
        if (b.set.split(",").includes(a)) {
          matchedKampo[i].count++;
          matchedKampo[i].set = matchedKampo[i].set.replace(a, `<b>${a}</b>`);
        }
      });
    });
    matchedKampo = matchedKampo
      .filter((item) => item.count > 0)
      .sort((a, b) => {
        if (a.count > b.count) return -1;
        if (a.count < b.count) return 1;
        return 0;
      });
    setReleventOTCKampo(matchedKampo);
  };
  if (kampo && !searched) {
    setSearched(true);
    search(kampo);
  }

  const columns = useMemo(
    () => [
      {
        accessorKey: "count",
        header: "一致生薬数",
        filterVariant: "range",
      },
      {
        accessorKey: "id",
        header: "処方番号",
      },
      {
        accessorKey: "name",
        header: "名前",
      },
      {
        accessorKey: "set",
        header: "生薬",
        Cell: ({ cell }) => (
          <div dangerouslySetInnerHTML={{ __html: cell.getValue() }} />
        ),
      },
    ],
    []
  );

  return (
    <ResponsiveDrawer>
      <div style={{ maxWidth: "calc(100vw - 48px)" }}>
        <Typography paragraph>類似漢方検索</Typography>
        <Autocomplete
          autoSelect
          options={AllKampoData}
          getOptionLabel={(option) => option.kana ? `${option.name}（${option.kana}）` : option.name}
          filterOptions={(options, { inputValue }) => {
            if (!inputValue) return options;
            return options.filter((option) =>
              matchesKanaSearch(inputValue, option.name, option.kana)
            );
          }}
          onChange={handleChange}
          renderInput={(params) => (
            <TextField
              {...params}
              label="漢方方剤（ひらがな・カタカナで検索可）"
              variant="outlined"
            />
          )}
          defaultValue={selectedKampo}
        />
        {selectedKampo && (
          <>
            <Box mb={2} />
            <Typography paragraph>
              使用されている生薬:{" "}
              <b>{selectedKampo.set.split(",").join(", ")}</b>
            </Typography>
            <Box mb={3} />
            <MaterialReactTable
              columns={columns}
              data={releventOTCKampo || []}
              enableColumnFilterModes
              enableColumnOrdering
              enableGrouping
              enablePinning
              enableRowSelection={false}
              initialState={{ density: "compact" }}
              renderTopToolbarCustomActions={() => (
                <Typography paragraph style={{ margin: 0 }}>関連一般用漢方製剤製造販売承認基準</Typography>
              )}
            />
          </>
        )}
      </div>
    </ResponsiveDrawer>
  );
}

export default ReleventSearch;
